import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 主体类型
 */
class BusinessType extends UltMeta {
    SUPPLIER = new Meta(1, "供应链");
    CUSTOM = new Meta(2, "客户");
}
export const MAIN_BUSINESS_TYPE = new BusinessType();

/**
 * 认证状态
 */
class ApplyStateType extends UltMeta {
    PENDING_APPROVE = new Meta(1, "待审核");
    REJECTED = new Meta(2, "已驳回");
    APPROVED = new Meta(3, "已认证");
    UNVERIFIED = new Meta(4, "未认证");
}
export const APPLY_STATE_TYPE = new ApplyStateType();

/**
 * 企业关系
 */
class EnterpriseRelationType extends UltMeta {
    MAIN = new Meta(1, "主企业");
    ASSOCIATED = new Meta(2, "关联企业");
}
export const ENTERPRISE_RELATION_TYPE = new EnterpriseRelationType();

/**
 * 电子签章授权
 */
class SealAuthorizationType extends UltMeta {
    YES = new Meta(1, "已授权");
    NO = new Meta(2, "未授权");
}
export const SEAL_AUTHORIZATION_TYPE = new SealAuthorizationType();
